import { useMemo } from 'react'
import { defineMessage, useIntl } from 'react-intl'

import Places from 'constants/places'

export const anywhereLabelMessage = defineMessage({
  id: 'kVUTD8LjFWYGCcXOICyq',
  defaultMessage: 'Anywhere',
})

export default function useAnywherePlace(): App.Place {
  const intl = useIntl()
  const name = intl.formatMessage(anywhereLabelMessage)

  return useMemo(() => ({ id: Places.Anywhere.id, name }), [name])
}
